import { render, staticRenderFns } from "./CaseDisplayer.vue?vue&type=template&id=b8705518&scoped=true"
import script from "./CaseDisplayer.vue?vue&type=script&lang=ts"
export * from "./CaseDisplayer.vue?vue&type=script&lang=ts"
import style0 from "./CaseDisplayer.vue?vue&type=style&index=0&id=b8705518&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8705518",
  null
  
)

export default component.exports